import { useNavigate } from "react-router-dom";
import { ROUTE_PATH } from "@/constants/routeConstants";
import { Button } from "@/components/ui/button";
import { Typography } from "@/components/ui/typography";

export default function NotFoundPage() {
  const navigate = useNavigate();
  const handleGoHome = () => {
    navigate(ROUTE_PATH.ROUTE_DASHBOARD);
  };

  return (
    <div className='min-h-screen w-full flex flex-col items-center justify-center bg-grey-200 dark:bg-[#202832] p-4'>
      <div className='text-center space-y-3'>
        <Typography variant='bold-32'>404</Typography>
        <Typography variant='bold-22'>Page Not Found</Typography>
        <Typography variant='medium-16'>
          Oops! The page you're looking for doesn't exist.
        </Typography>
        <Button
          onClick={handleGoHome}
          size='lg'
          className='mt-8 bg-primary-700 hover:bg-primary-700 dark:bg-primary-600 text-white dark:hover:bg-primary-600'>
          Back to Dashboard
        </Button>
      </div>
    </div>
  );
}
